const handleDeleteDocumentFormService = {
  confirm: '¿Realmente desea eliminar esta entrada?',
  title: 'ELIMINAR DOCUMENTO'
};

export default handleDeleteDocumentFormService;
